module.exports = __webpack_public_path__ + "static/media/logo.aa4f0960.png";